import { render, staticRenderFns } from "./new_list.vue?vue&type=template&id=3204e7e2&scoped=true&"
import script from "./new_list.vue?vue&type=script&lang=js&"
export * from "./new_list.vue?vue&type=script&lang=js&"
import style0 from "./new_list.vue?vue&type=style&index=0&id=3204e7e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3204e7e2",
  null
  
)

component.options.__file = "new_list.vue"
export default component.exports